import React from 'react';
import { Type } from 'lucide-react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';

const TextsTab = ({ item, onUpdate, themeColors }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <div className="space-y-6">
      {/* Kopftext */}
      <div>
        <label className={`block text-sm font-medium ${isDarkMode ? 'text-white/90' : 'text-gray-700'} mb-2 flex items-center drop-shadow-sm`}>
          <Type className="w-4 h-4 mr-1.5" />
          {t('banf.texts.headerText')}
        </label>
        <div className="relative">
          <div className={`absolute inset-0 ${isDarkMode ? 'bg-gray-800/30 border border-white/30' : 'bg-white/50 border border-blue-200/40'} backdrop-blur-xl rounded-2xl shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]`}></div>
          <textarea
            value={item.header_text || ''}
            onChange={(e) => onUpdate(item.id, 'header_text', e.target.value)}
            rows={4}
            className={`relative w-full px-3 py-2 bg-transparent border-0 rounded-2xl focus:ring-2 ${themeColors.focusRing} focus:outline-none transition-all duration-300 resize-none ${isDarkMode ? 'text-white placeholder-white/60' : 'text-gray-800 placeholder-gray-400'}`}
            placeholder={t('banf.texts.headerTextPlaceholder')}
          />
        </div>
        <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} mt-1`}>
          {t('banf.texts.headerTextHint')}
        </p>
      </div>

      {/* Positionstext */}
      <div>
        <label className={`block text-sm font-medium ${isDarkMode ? 'text-white/90' : 'text-gray-700'} mb-2 flex items-center drop-shadow-sm`}>
          <Type className="w-4 h-4 mr-1.5" />
          {t('banf.texts.itemText')}
        </label>
        <div className="relative">
          <div className={`absolute inset-0 ${isDarkMode ? 'bg-gray-800/30 border border-white/30' : 'bg-white/50 border border-blue-200/40'} backdrop-blur-xl rounded-2xl shadow-[inset_0_1px_0_rgba(255,255,255,0.2)]`}></div>
          <textarea
            value={item.position_text}
            onChange={(e) => onUpdate(item.id, 'position_text', e.target.value)}
            rows={6}
            className={`relative w-full px-3 py-2 bg-transparent border-0 rounded-2xl focus:ring-2 ${themeColors.focusRing} focus:outline-none transition-all duration-300 resize-none ${isDarkMode ? 'text-white placeholder-white/60' : 'text-gray-800 placeholder-gray-400'}`}
            placeholder={t('banf.texts.itemTextPlaceholder')}
          />
        </div>
        <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'} mt-1`}>
          {t('banf.texts.itemTextHint')}
        </p>
      </div>
    </div>
  );
};

export default TextsTab;